import React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

const Separator = React.forwardRef(
  ({ orientation = "horizontal", className = "", ...props }, ref) => {
    return (
      <SeparatorPrimitive.Root
        ref={ref}
        orientation={orientation}
        className={`
        shrink-0 bg-gray-600
        ${orientation === "horizontal" ? "h-px w-full" : "h-full w-px"}
        ${className}
      `}
        {...props}
      />
    );
  }
);

Separator.displayName = "Separator";

export default Separator;
